// Angular modules
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// External modules
import { TranslateModule } from '@ngx-translate/core';

// Material modules
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { FlexModule } from '@angular/flex-layout';
import { MatNativeDateModule } from '@angular/material/core';

import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';

// Internal modules

// Components
import { SelectFieldComponent } from './components/blocks/filter-engine/select-field/select-field.component';
import { InputFieldComponent } from './components/blocks/filter-engine/input-field/input-field.component';
import { DynamicListFieldSingleSelectComponent } from './components/blocks/filter-engine/dynamic-list-field/single-select/dynamic-list-field-single-select.component';
import { DynamicListFieldMultipleSelectsComponent } from './components/blocks/filter-engine/dynamic-list-field/multiple-selects/dynamic-list-field-multiple-selects.component';
import { DateIntervalFieldComponent } from './components/blocks/filter-engine/date-field/date-interval-field.component';
import { DeviceDetailPopupComponent } from '../home/devices/device-detail.component';
import { DateInputComponent } from './components/blocks/date-input/date-input.component';
import { NotificationComponent } from './components/blocks/notification/notification.component';
import { LoaderComponent } from './components/blocks/notification/loader/loader.component';

import { MatPaginatorIntlProvider } from './MatPaginatorIntlProvider';

// Forms

// Modals
import { MessageDialogComponent } from './components/dialogs/message-dialog/message-dialog.component';
import { YesNoDialogComponent } from './components/dialogs/yesno-dialog/yesno-dialog.component';

// Layouts

// Pipes
import { EnumToArrayPipe } from './pipes/enum-array.pipe';
import { DateFormatPipe } from './pipes/date-format.pipe';
import { UtcDateFormatPipe } from './pipes/utc-date-format.pipe';
import { WhereInPipe } from './pipes/where-in.pipe';

// Directives
import { FilterEngineDirective } from './components/blocks/filter-engine/filter-engine.directive';



@NgModule({
  exports:
    [
      // Material modules
      MatToolbarModule,
      MatCheckboxModule,
      MatCardModule,
      MatGridListModule,
      MatChipsModule,
      MatIconModule,
      MatProgressSpinnerModule,
      MatDialogModule,
      MatButtonModule,
      MatInputModule,
      MatSnackBarModule,
      MatRadioModule,
      MatSelectModule,
      MatTableModule,
      MatTabsModule,
      MatProgressBarModule,
      MatExpansionModule,
      MatSidenavModule,
      MatListModule,
      MatMenuModule,
      MatTooltipModule,
      MatPaginatorModule,
      MatDatepickerModule,
      MatNativeDateModule,
      MatFormFieldModule,
      MatButtonToggleModule,
      FlexModule
    ],
  providers: [
    { provide: MatPaginatorIntl, useClass: MatPaginatorIntlProvider }
  ],
  declarations: []
})
export class MaterialModule { }

@NgModule({
  imports:
    [
      // Angular modules
      CommonModule,
      RouterModule,
      FormsModule,
      ReactiveFormsModule,

      // Material modules
      MaterialModule,

      //NgxMaterialTimepickerModule,
      NgxMaterialTimepickerModule.setLocale('de-DE'),

      // External modules
      TranslateModule,

      // Internal modules
      // NotificationModule
    ],
  declarations:
    [
      // Components
      SelectFieldComponent,
      InputFieldComponent,
      DynamicListFieldSingleSelectComponent,
      DynamicListFieldMultipleSelectsComponent,
      DateIntervalFieldComponent,
      DeviceDetailPopupComponent,
      DateInputComponent,
      NotificationComponent,
      LoaderComponent,

      // Forms

      // Modals
      MessageDialogComponent,
      YesNoDialogComponent,

      // Layouts

      // Pipes
      EnumToArrayPipe,
      DateFormatPipe,
      UtcDateFormatPipe,
      WhereInPipe,

      // Directives
      FilterEngineDirective,
    ],
  entryComponents:
    [
      // Components
      MessageDialogComponent,
      YesNoDialogComponent,
    ],
  exports:
    [
      // Angular modules
      CommonModule,
      RouterModule,
      FormsModule,
      ReactiveFormsModule,

      // Material modules
      MaterialModule,

      // External modules
      TranslateModule,

      // Internal modules
      // NotificationModule,

      // Components
      SelectFieldComponent,
      InputFieldComponent,
      DynamicListFieldSingleSelectComponent,
      DynamicListFieldMultipleSelectsComponent,
      DateIntervalFieldComponent,
      DeviceDetailPopupComponent,
      DateInputComponent,
      NotificationComponent,
      LoaderComponent,

      // Forms

      // Modals
      MessageDialogComponent,
      YesNoDialogComponent,

      // Layouts

      // Pipes
      EnumToArrayPipe,
      DateFormatPipe,
      UtcDateFormatPipe,
      WhereInPipe,

      // Directives
      FilterEngineDirective,
    ],
  providers:
    [
    ]
})
export class SharedModule { }
